import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "mining",
  "use": "mining-usage",
  "viewBox": "0 0 78.792099 80.93158",
  "content": "<symbol viewBox=\"0 0 78.792099 80.93158\" id=\"mining\"><path d=\"M0 56.779l33.7-33.7 6.762 6.763-33.7 33.699zM50.333 8.084l-4.9 3.261 6.763 6.762 3.26-4.899z\" /><path d=\"M43.414 27.513c5.359 5.996 10.087 12.56 13.969 19.591l.105.193c-.18-.334.576-2.366.639-2.773.375-2.416.364-4.897.016-7.315-1.416-9.829-8.697-17.557-15.872-23.887-6.55-5.779-15.435-9.9-24.384-7.738-.264.063-1.445.576-1.643.469 10.055 5.45 19.464 12.837 27.17 21.46zM41.429 42.637a1.501 1.501 0 0 0 .107 2.119l5.167 4.667c.287.26.647.387 1.006.387a1.501 1.501 0 0 0 1.006-2.613l-5.167-4.668a1.5 1.5 0 0 0-2.12.108zM65.28 47.213a1.502 1.502 0 0 0 1.94-.857l2.389-6.172a1.5 1.5 0 0 0-2.8-1.083l-2.387 6.171a1.5 1.5 0 0 0 .858 1.94zM44.462 55.345c-.058-.827-.802-1.462-1.602-1.39l-7.423.525a1.5 1.5 0 1 0 .21 2.992l7.424-.525a1.5 1.5 0 0 0 1.391-1.602zM61.487 65.278l-2.473 10.654h19.778l-3.621-18.377zM60.128 62.6l12.648-7.138-15.8-4.11-7.567 5.953zM55.934 75.932l2.511-10.818-10.99-5.429-7.788 16.247z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ../assets/icons/mining.svg
// module id = 306
// module chunks = 0